<template>
<el-dialog :title="!dataForm.userId ? '新增' : '修改'" :close-on-click-modal="false" :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="80px">
        <el-form-item label="真实姓名" prop="realName">
            <el-input v-model="dataForm.realName" placeholder="真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="账户名" prop="username">
            <el-input v-model="dataForm.username" placeholder="账户名"></el-input>
        </el-form-item>
        <el-form-item label="所属机构" prop="orgId">
            <el-dict-select v-model="dataForm.orgId" type="orgList"></el-dict-select>
        </el-form-item>
        <el-form-item label="角色" prop="roleIdList">
            <el-dict-select v-model="dataForm.roleIdList" multiple type="roleList" :params="rolelistParams" :props="{ value: 'roleId', label: 'roleName' }"></el-dict-select>
        </el-form-item>
        <el-form-item label="用户类型" prop="userType" v-if="manageOrgIdFlag() || dataForm.userId === ''|| dataForm.userId === undefined">
            <el-dict-select v-model="dataForm.userType" type="listByType" :params="userTypeParams" :props="dictProps"></el-dict-select>
        </el-form-item>
        <!-- <el-form-item label="用户类型" prop="userType"
         v-if="(!manageOrgIdFlag()) && dataForm.userId">
        <el-dict-select
          disabled
          v-model="dataForm.userType"
          type="listByType"
          :params="userTypeParams"
          :props="dictProps"
        ></el-dict-select>
      </el-form-item>-->
        <el-form-item label="性别" prop="gender">
            <el-dict-select v-model="dataForm.gender" type="listByType" :params="genderParams" :props="dictProps"></el-dict-select>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
            <el-input v-model="dataForm.mobile" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
            <el-input v-model="dataForm.email" placeholder="邮箱"></el-input>
        </el-form-item>
        <template v-if="user.userType === 'P_MANAGER'">
            <el-form-item label="邀请名额" prop="inviteQuota">
                <el-input v-model.number="dataForm.inviteQuota" placeholder="请输入邀请名额"></el-input>
            </el-form-item>
        </template>
        <el-form-item label="状态" size="mini" prop="status">
            <el-radio-group v-model="dataForm.status">
                <el-radio label="0">禁用</el-radio>
                <el-radio label="1">启用</el-radio>
            </el-radio-group>
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <span style="margin-right: 300px; font-size: xx-small" v-if="!dataForm.userId"><span style="color: red">注意事项</span>: 新增用户默认密码 456123，为了防止盗号，请尽快修改！</span>
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="dataFormSubmit()" :loading="loading">确定</el-button>
    </span>
</el-dialog>
</template>

<script>
let validatorPhone = function (rule, value, callback) {
    if (value === '') {
        callback(new Error('手机号不能为空'))
    } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error('手机号格式错误'))
    } else {
        callback()
    }
}
export default {
    data() {
        return {
            loading: false,
            dictProps: {
                value: "code",
                label: "value",
            },
            visible: false,
            dataForm: {
                username: "",
                orgId: "",
                realName: "",
                userType: "",
                gender: "",
                email: "",
                mobile: "",
                inviteQuota: "",
                roleIdList: [],
                status: "1",
            },
            dataRule: {
                username: [{
                    required: true,
                    message: "请输入账户名",
                    trigger: "blur"
                }, ],
                mobile: [{
                    required: true,
                    validator: validatorPhone,
                    trigger: "blur"
                }, ],
                roleIdList: [{
                    required: true,
                    message: "请选择角色",
                    trigger: "blur"
                }, ],
            },
        };
    },
    methods: {
        init(userId) {
            this.dataForm.userId = userId;
            this.visible = true;
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.userId) {
                    this.$http({
                        url: this.$http.adornUrl(`sys/user/info/${this.dataForm.userId}`),
                        method: "get",
                    }).then(({
                        data
                    }) => {
                        if (data && data.code === 0) {
                            this.dataForm.username = data.user.username;
                            this.dataForm.realName = data.user.realName;
                            this.dataForm.orgId = data.user.orgId;
                            this.dataForm.userType = data.user.userType;
                            this.dataForm.gender = data.user.gender;
                            this.dataForm.email = data.user.email;
                            this.dataForm.mobile = data.user.mobile;
                            this.dataForm.inviteQuota = data.user.inviteQuota;
                            this.dataForm.status = data.user.status;
                            this.$nextTick(() => {
                                this.dataForm.roleIdList = data.user.roleIdList;
                            });
                        }
                    });
                }
            });
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    this.$http({
                            url: this.$http.adornUrl(
                                `sys/user/${
                                !this.dataForm.userId
                                  ? "save"
                                  : "update/" + this.dataForm.userId
                              }`
                            ),
                            method: `${this.dataForm.userId ? "put" : "post"}`,
                            data: this.$http.adornData(this.dataForm),
                        })
                        .then(({
                            data
                        }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: this.dataForm.userId ? "更新成功" : "新建成功",
                                    type: "success",
                                });
                                this.visible = false;
                                this.$emit("refreshDataList");
                            } else {
                                this.$message.error(data.msg);
                            }
                            this.loading = false;
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                }
            });
        },
    },
    computed: {
        genderParams() {
            return {
                type: "Gender"
            };
        },
        rolelistParams() {
            return {
                orgId: this.dataForm.orgId,
            };
        },
        userTypeParams() {
            return {
                type: "UserType"
            };
        },
        user() {
            return JSON.parse(this.$cookie.get("loginUser"));
        },
    },
};
</script>
